/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import Toggle from 'app/components/common/ToggleControl.jsx';
import FormUtilityMixin from 'app/mixins/FormUtilityMixin.js';
import * as _ from 'underscore';

export default function ShortenerDetailWrapper(Component) {
    class ShortenerDetailWrapper extends React.Component {
        constructor(props) {
            super(props);

            this.state = {
                data: _.clone(this.props.detail),
                isConnecting: false
            };

            this.connectService = this.connectService.bind(this);
            this.convertValueForToggle = this.convertValueForToggle.bind(this);
            this.updateSystemDefault = this.updateSystemDefault.bind(this);
            this.update = this.update.bind(this);
            this.save = this.save.bind(this);
            this.cancel = this.cancel.bind(this);
            this.getApplyButtons = this.getApplyButtons.bind(this);
            this.getSaveButtons = this.getSaveButtons.bind(this);
            this.clearErrors = this.clearErrors.bind(this);
            this.newShortener = this.newShortener.bind(this);

        }

        componentDidUpdate(prevProps, prevState) {

            if (!_.isEqual(this.props.detail, prevProps.detail)) {
                this.setState({
                    data: _.clone(this.props.detail)
                });
            }
        }

        connectService(e) {
    		let serviceId = e.currentTarget.dataset.serviceid,
    			url = "/remote/begin?ssID=:ssId&state=:state&final=:final",
    			date = new Date(),
    			state = ['SHORTEN', serviceId, date.getTime()].join("_"),
    			constants = this.props.app.config.constants;

    		e.preventDefault();

            if (this.state.isConnecting) {
                return;
            }

            this.setState({
                isConnecting: true
            }, () => {
                url = url.replace(':ssId', serviceId);
        		url = url.replace(':state', state);
        		url = url.replace(':final', window.encodeURIComponent(window.location.href));
        		window.location.assign(url);
            });

    	}

        convertValueForToggle(val) {
            return (parseInt(val, 10) === 1) ? true : false;
        }

        updateSystemDefault(e) {

            let pdId = parseInt(this.props.defaultPdId, 10),
                saId = parseInt(this.props.defaultSaId, 10);

            // this is already a system default, the user can't turn it off.
            if (e.currentTarget.dataset.togglestate === 'true' &&
                (this.state.data.id == pdId) || (pdId === 0 && this.state.data.id === saId)) {
                return;
            } else {
                // this was in a false state, so they're setting a different default which is OK
                this.update(e);
            }

        }

        clearErrors() {
            // clear out prior errors
            this.props.deleteApiError([
    			'DOMAIN_CREATE',
    			'DOMAIN_UPDATE',
    			'DOMAIN_DELETE',
    			'SHORTENER_CREATE',
    			'SHORTENER_UPDATE',
    			'SHORTENER_DELETE',
    			'SHORTENER_TEST'
    		]);
        }

        update(e) {

            if (this.props.updateField !== null) {
                this.props.updateField(e);
            } else {
                FormUtilityMixin.requestChange.apply(this, [e]);
            }

        }

        save(e) {
            let newEntity = this.state.data,
                constants = this.props.app.config.constants;
            // clear out prior errors
            this.clearErrors();

            e.preventDefault();

            if (this.state.data.ssID !== undefined && this.state.data.ssID === constants.SHORTEN_SVC_BITLY) {
                newEntity.credID = this.props.creds;
                this.props.createShortener(newEntity);
            } else if (this.state.data.ssID !== undefined && this.state.data.ssID === constants.SHORTEN_SVC_CUSTOM) {
                this.props.createShortener(newEntity);
            } else if (this.state.data.type !== undefined && this.state.data.type === constants.PUB_DOMAIN){
                this.props.createDomain(newEntity);
            }

        }

        cancel(e) {

            this.clearErrors();
            this.props.router.navigate('/config/shorteners');

        }

        getApplyButtons() {
            let applyButtons = null;

            if (parseInt(this.props.app.flags.routeViewType, 10) === 0) {
                applyButtons = (
                    <div>
                        <fieldset>
                            <legend>Apply to Existing Routes</legend>
                            <Toggle
                                active={this.convertValueForToggle(this.state.data.applyRoutes)}
                                callback={this.update}
                                linkedField="data.applyRoutes"
                                noLabel={true}
                                toggleClass="inline" />
                            <span className="form-inline-label light">Apply this {this.props.typeLabel} to your existing routes</span>
                        </fieldset>
                        <fieldset>
                            <legend>Apply to Existing Socials</legend>
                            <Toggle
                                active={this.convertValueForToggle(this.state.data.applyOutputs)}
                                callback={this.update}
                                linkedField="data.applyOutputs"
                                noLabel={true}
                                toggleClass="inline" />
                            <span className="form-inline-label light">Apply this {this.props.typeLabel} to your existing socials</span>
                        </fieldset>
                    </div>
                );
            } else {
                applyButtons = (
                    <fieldset>
                        <legend>Apply to Existing</legend>
                        <Toggle
                            active={this.convertValueForToggle(this.state.data.applyOutputs)}
                            callback={this.update}
                            linkedField="data.applyOutputs"
                            noLabel={true}
                            toggleClass="inline" />
                        <span className="form-inline-label light">Apply this shortener to your existing automated sharing</span>
                    </fieldset>
                );
            }

            return applyButtons;
        }

        getSaveButtons() {
            let buttons = null,
                saveButton = null,
                constants = this.props.app.config.constants;

            if (this.state.data === undefined) {
                return buttons;
            }

            if ((this.state.data.ssID == constants.SHORTEN_SVC_BITLY && this.props.creds !== '') ||
                (this.state.data.ssID == constants.SHORTEN_SVC_GOOGL && this.props.creds !== '') ||
                (this.state.data.ssID == constants.SHORTEN_SVC_CUSTOM) ||
                (this.state.data.type == constants.PUB_DOMAIN)) {
                saveButton = (
                    <button className="btn-primary active fixed" onClick={this.save}>
                        Save
                    </button>
                );
            }

            if (this.props.onNewTypeChange !== undefined) {
                buttons = (
                    <fieldset>
                        <div className="form-buttons">
                            <div className="cancel-button" onClick={this.cancel} role='button' aria-label="cancel">cancel</div>
                            {saveButton}
                        </div>
                    </fieldset>
                );
            }

            return buttons;

        }

        newShortener(data) {
            this.setState({
                data
            });
        }

        render() {
            return (
                <Component
                    {...this.props}
                    data={this.state.data}
                    connectService={this.connectService}
                    convertValueForToggle={this.convertValueForToggle}
                    updateSystemDefault={this.updateSystemDefault}
                    update={this.update}
                    save={this.save}
                    cancel={this.cancel}
                    getApplyButtons={this.getApplyButtons}
                    getSaveButtons={this.getSaveButtons}
                    requestChange={FormUtilityMixin.requestChange.bind(this)}
                    newShortener={this.newShortener} />
            );
        }

    }

    ShortenerDetailWrapper.displayName = "ShortenerDetailWrapper";

    ShortenerDetailWrapper.propTypes = {
        data: PropTypes.object,
        updateField: PropTypes.func,
        creds: PropTypes.string,
        errors: PropTypes.object,
        state: PropTypes.string,
        typeLabel: PropTypes.string,
        defaultPdId: PropTypes.oneOfType([
			PropTypes.number,
			PropTypes.string
		]),
		defaultSaId: PropTypes.oneOfType([
			PropTypes.number,
			PropTypes.string
		])
    };

    ShortenerDetailWrapper.defaultProps = {
            data: {},
            connectHandler: null,
            updateField: null,
            creds: '',
            errors: null,
            state: 'new',
            typeLabel: ''
    };

    return ShortenerDetailWrapper;

};
